import { extractLocaleFromUbisoftURL } from "../ubisoft/locale";
import { init } from "./adobe-analytics";
import { CONFIG } from "../config";
export function initAnalytics() {
    var ubiLocale = extractLocaleFromUbisoftURL(window.location.href) || "en-gb";
    var language = ubiLocale.split("-")[0];
    var country = ubiLocale.split("-")[1];
    init({
        language: language,
        country: country,
        appId: process.env.UBISOFT_APP_ID,
        genomeId: process.env.UBISOFT_GENOME_ID,
        siteName: CONFIG.analytics.siteName,
        siteType: "artbook",
        environment: process.env.ADOBE_ANALYTICS_ENV,
        region: getAnalyticsRegion(country),
        mdmBrandId: CONFIG.analytics.mdmBrandId,
        mdmInstallmentId: CONFIG.analytics.mdmInstallmentId,
        installmentName: CONFIG.analytics.installmentName,
        brandName: CONFIG.analytics.brandName,
    });
}
var NCSA_COUNTRIES = ["us", "ca", "mx", "br"];
export function getAnalyticsRegion(country) {
    if (NCSA_COUNTRIES.indexOf(country.toLowerCase()) !== -1) {
        return "ncsa";
    }
    else {
        return "emea";
    }
}
